module.exports = __webpack_public_path__ + "static/media/Summer_Banner.e22450a8.png";